import { render, staticRenderFns } from "./preEthnic.vue?vue&type=template&id=06e4401c&scoped=true&"
import script from "./preEthnic.vue?vue&type=script&lang=js&"
export * from "./preEthnic.vue?vue&type=script&lang=js&"
import style0 from "./preEthnic.vue?vue&type=style&index=0&id=06e4401c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e4401c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
